module.exports = __webpack_public_path__ + "img/VideoconD2H.7d2762e7.png";